// Accordion open/close toggle

(function ( $ ) {
    $( '.accordion-toggle' ).click( function ( e ) {
        e.preventDefault();
        $( this ).next( '.accordion-contents' ).slideToggle( 'fast' ).parent().toggleClass( 'is-expanded' );
    } );
})( jQuery );
